export default function StocksConfigurationProduitsConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('stocks.configuration.produits');
}

StocksConfigurationProduitsConfiguration.$inject = ['$translatePartialLoaderProvider'];
